






























import Vue, { PropType } from "vue";
import Price from "@/lib/price";
import Date from "@/lib/convertDate";
import Locale from "@/lib/locale";

export interface CloudContractsChangePlansPaymentInformationProps {
  lang: any;
  currencyCode: string;
  isUpgrade: boolean;
  newPlanTerm: string;
  newPlanPrice: number;
  nextInvoiceAt: number;
  priceDifference: number;
}

export default Vue.extend({
  name: "vc-about-cloud-contracts-change-plans-payment-information",
  props: {
    lang: {
      type: Object as PropType<
        CloudContractsChangePlansPaymentInformationProps["lang"]
      >,
      default: () => {}
    },
    currencyCode: {
      type: String as PropType<
        CloudContractsChangePlansPaymentInformationProps["currencyCode"]
      >,
      default: ""
    },
    isUpgrade: {
      type: Boolean as PropType<
        CloudContractsChangePlansPaymentInformationProps["isUpgrade"]
      >,
      default: false
    },
    newPlanTerm: {
      type: String as PropType<
        CloudContractsChangePlansPaymentInformationProps["newPlanTerm"]
      >,
      default: ""
    },
    newPlanPrice: {
      type: Number as PropType<
        CloudContractsChangePlansPaymentInformationProps["newPlanPrice"]
      >,
      default: 0
    },
    nextInvoiceAt: {
      type: Number as PropType<
        CloudContractsChangePlansPaymentInformationProps["nextInvoiceAt"]
      >,
      default: 0
    },
    priceDifference: {
      type: Number as PropType<
        CloudContractsChangePlansPaymentInformationProps["priceDifference"]
      >,
      default: 0
    }
  },

  computed: {
    newPlanPriceText(): string {
      if (!this.newPlanTerm) return "";

      const newPlanPrice =
        this.newPlanTerm === "year"
          ? this.lang.payment_information.yearly_price
          : this.lang.payment_information.monthly_price;

      return newPlanPrice.replace(
        ":price",
        Price.getPrice(this.currencyCode, this.newPlanPrice)
      );
    },
    nextInvoiceAtText(): string {
      if (!this.nextInvoiceAt) return "";
      return this.lang.payment_information.next_invoice_at.replace(
        ":date",
        Date.getDate(this.nextInvoiceAt, Locale.getLocale(), "yyyy/M/d")
      );
    },
    priceDifferenceText(): string {
      if (!this.priceDifference) return "";
      return this.lang.payment_information.price_difference_caption.replace(
        ":price",
        Price.getPrice(this.currencyCode, this.priceDifference)
      );
    }
  }
});
